import { useState, useCallback } from 'react'
import styled from 'styled-components/macro'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Keyboard } from 'swiper'
import { SwiperStyle, SliderStyle } from './MaximizedGallery.Swiper.style'
import { SwiperNav } from './MaximizedGallery.Navigation'
import { CatchSlide } from './MaximizedGallery.catch'
import { IconButton } from "@mui/material"
import { Icon } from "components/Icons"


export const Slider = ({ initial, images }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  const swiperProps = {
    modules      : [Keyboard],
    slidesPerView: 1,
    spaceBetween : 20,
    initialSlide : initial ?? 0,
    keyboard     : { enabled: true },
    onSlideChange: (e) => setActiveIndex(e.activeIndex),
  }

  return (
    <StyleInjection>
      <Swiper {...swiperProps}>

        {images?.length > 1 && <SwiperNav activeIndex={activeIndex} {...{ images }} />}

        {images?.map((img, i) => (
          <SwiperSlide key={i}>
            <img
              src={img.url}
              alt=""
              style={{
                display      : "block",
                width        : "auto",
                maxWidth     : "100%",
                height       : "auto",
                maxHeight    : "calc(90vh - 120px)",
                objectFit    : "contain",
                borderRadius : "6px",
              }}
            />
            <CatchSlide />
          </SwiperSlide>
        ))}
      </Swiper>
    </StyleInjection>
  )
}
const StyleInjection = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  ${SwiperStyle}
  ${SliderStyle}
`